const topics = [
  { id: 1, name: '科幻大片', heat: '2.3w', icon: 'ri-rocket-line' },
  { id: 2, name: '悬疑推理', heat: '1.8w', icon: 'ri-search-eye-line' },
  { id: 3, name: '古装权谋', heat: '2.1w', icon: 'ri-ancient-gate-line' },
  { id: 4, name: '国产动漫', heat: '1.6w', icon: 'ri-brush-line' },
  { id: 5, name: '韩剧推荐', heat: '1.5w', icon: 'ri-heart-line' },
  { id: 6, name: '好莱坞', heat: '1.3w', icon: 'ri-film-line' },
  { id: 7, name: '纪录片', heat: '8921', icon: 'ri-earth-line' },
  { id: 8, name: '喜剧电影', heat: '1.1w', icon: 'ri-emotion-laugh-line' },
  { id: 9, name: '犯罪动作', heat: '9678', icon: 'ri-knife-line' },
  { id: 10, name: '日剧精选', heat: '7854', icon: 'ri-sun-line' },
  { id: 11, name: '爱情电影', heat: '1.4w', icon: 'ri-heart-2-line' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-5xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium tracking-wide mb-3">
            热议
          </span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base mt-2 max-w-lg mx-auto">
            全网影视爱好者正在热议的话题标签
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topics.map((topic) => (
            <div
              key={topic.id}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50/50 transition-all cursor-pointer"
            >
              <div className="w-5 h-5 flex items-center justify-center text-primary-500">
                <i className={`${topic.icon} text-sm`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors">
                {topic.name}
              </span>
              <span className="text-xs text-foreground-400 bg-background-100 px-1.5 py-0.5 rounded-full">
                {topic.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}